import React from 'react';
import {
  Typography,
  Box,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Chip,
} from '@mui/material';
import { Logout } from '@mui/icons-material';
import { getRoleColor, getRoleDisplayName } from './navItems';

/**
 * Gebruikersmenu (avatar rechtsboven).
 * `items` is al gefilterd op rechten.
 */
export default function NavUserMenu({
  anchorEl,
  onClose,
  user,
  role,
  items,
  onItemClick,
  onLogout,
}) {
  return (
    <Menu
      id="menu-appbar"
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={Boolean(anchorEl)}
      onClose={onClose}
      sx={{
        mt: 1,
        '& .MuiPaper-root': {
          borderRadius: 2,
          minWidth: 200,
          boxShadow: 8,
          border: 1,
          borderColor: 'divider',
        },
      }}
    >
      {/* User Info Header */}
      <Box sx={{ px: 2, py: 1.5, borderBottom: 1, borderColor: 'divider' }}>
        <Typography variant="body2" sx={{ fontWeight: 600, color: 'text.primary' }}>
          {user?.email}
        </Typography>
        <Chip
          label={getRoleDisplayName(role)}
          size="small"
          color={getRoleColor(role)}
          sx={{ mt: 0.5, fontSize: '0.75rem' }}
        />
      </Box>

      {items.map(({ path, label, icon: Icon }) => (
        <MenuItem key={path} onClick={() => onItemClick(path)} sx={{ py: 1.5 }}>
          <ListItemIcon>
            <Icon fontSize="small" />
          </ListItemIcon>
          <ListItemText>{label}</ListItemText>
        </MenuItem>
      ))}
      <Divider />
      <MenuItem onClick={onLogout} sx={{ py: 1.5, color: 'error.main' }}>
        <ListItemIcon>
          <Logout fontSize="small" sx={{ color: 'error.main' }} />
        </ListItemIcon>
        <ListItemText>Uitloggen</ListItemText>
      </MenuItem>
    </Menu>
  );
}
